export default {
  F: 'Feminino',
  M: 'Masculino',
  null: 'Não Informado',
};
